import { c as _c } from "react/compiler-runtime";
import type { Language, Locale } from '@onefootprint/request-types';
import type React from 'react';
import { createContext, type JSX, useContext } from 'react';
export type L10nContextProviderProps = {
  children: React.ReactNode;
  l10n?: {
    locale?: Locale;
    language?: Language;
  };
};
export const L10nContext = createContext<{
  locale?: Locale;
  language?: Language;
} | undefined>({
  locale: 'en-US',
  language: 'en'
});
export const useL10nContext = () => {
  return useContext(L10nContext);
};
export const L10nContextProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    l10n
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== l10n) {
    t1 = <L10nContext.Provider value={l10n}>{children}</L10nContext.Provider>;
    $[0] = children;
    $[1] = l10n;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};